export default "__VITE_ASSET__DfTwufUa__"